import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export function LanguageSwitcher({ variant = 'default' }) {
  const { i18n } = useTranslation();
  
  const languages = [
    { code: 'es', label: 'ES', fullName: 'Español' },
    { code: 'en', label: 'EN', fullName: 'English' },
  ];
  
  const currentLang = i18n.language || 'es';
  
  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    // Persist preference
    localStorage.setItem('preferred_language', langCode);
  };

  if (variant === 'minimal') {
    // Minimal version for navbar - just flags/codes
    return (
      <div className="flex items-center gap-1 text-sm">
        {languages.map((lang, idx) => (
          <React.Fragment key={lang.code}>
            {idx > 0 && <span className="text-gray-300">|</span>}
            <button
              onClick={() => changeLanguage(lang.code)}
              className={`px-1 py-0.5 rounded transition-colors ${
                currentLang === lang.code
                  ? 'text-gold font-semibold'
                  : 'text-secondary hover:text-gold'
              }`}
              style={currentLang === lang.code ? { color: '#D4A574' } : {}}
              data-testid={`lang-${lang.code}`}
            >
              {lang.label}
            </button>
          </React.Fragment>
        ))}
      </div>
    );
  }

  // Default version with icon
  return (
    <div className="flex items-center gap-2">
      <Globe className="h-4 w-4 text-secondary" />
      <div className="flex items-center gap-1 text-sm">
        {languages.map((lang, idx) => (
          <React.Fragment key={lang.code}>
            {idx > 0 && <span className="text-gray-300 mx-1">|</span>}
            <button
              onClick={() => changeLanguage(lang.code)}
              className={`px-2 py-1 rounded transition-colors ${
                currentLang === lang.code
                  ? 'bg-gold/10 text-gold font-semibold'
                  : 'text-secondary hover:text-gold hover:bg-gray-100'
              }`}
              style={currentLang === lang.code ? { color: '#D4A574' } : {}}
              title={lang.fullName}
              data-testid={`lang-${lang.code}`}
            >
              {lang.label}
            </button>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default LanguageSwitcher;
